import { PortalRoutes } from "@lyteflo/types";
import {
  appendDealerContext,
  configureHttpClient,
  getProfileStore,
} from "@lyteflo/utils";
import { getLoginRoute } from "@utils/environment";

const REQUEST_TIMEOUT_MS = 30000;
const VEHICLE_API_PATH = "/vehicles/api";

export const initPortalWebHttpClient = () => {
  configureHttpClient({
    baseUrl: import.meta.env.VITE_API_BASE_URL,
    requestTimeout: REQUEST_TIMEOUT_MS,
    authPath: import.meta.env.VITE_API_AUTH,
    configurationPath: import.meta.env.VITE_API_CONFIGURATION,
    reportPath: import.meta.env.VITE_API_REPORT,
    inventoryPath: import.meta.env.VITE_API_INVENTORY,
    vehiclePath: VEHICLE_API_PATH,
    devicePath: import.meta.env.VITE_API_DEVICE,
    credentials: "include",
    onUnauthorized: () => {
      getProfileStore().clearProfile();
      const isOnLoginPage =
        window.location.pathname === PortalRoutes.LOGIN ||
        window.location.pathname === PortalRoutes.LYTEFLOGIN;
      if (!isOnLoginPage) {
        window.location.href = getLoginRoute();
      }
    },
    onBeforeRequest: appendDealerContext,
  });
};
